import { isNumber, pickBy } from 'lodash'

const resetInGameTime = (state) => {
  state.inGameDay = 1
  state.inGameHours = 0
  state.inGameMinutes = 0

  return state
}

export default {

  state: resetInGameTime({}),

  getters: {

    inGameDay ({ inGameDay }) {
      return inGameDay
    },

    inGameHours ({ inGameHours }) {
      return inGameHours
    },

    inGameMinutes ({ inGameMinutes }) {
      return inGameMinutes
    }

  },

  mutations: {

    resetInGameTime,

    setInGameTime (state, { inGameDay, inGameHours, inGameMinutes }) {
      const newState = pickBy({ inGameDay, inGameHours, inGameMinutes }, (value) => {
        return isNumber(value)
      })

      for (const key in newState) {
        state[key] = newState[key]
      }
    }

  },

  actions: {

    advanceInGameDay ({ dispatch, getters }, daysToAdvance) {
      dispatch('setInGameDay', getters.inGameDay + (daysToAdvance || 1))
    },

    advanceTime ({ dispatch }, minutes) {
      const hours = Math.floor(minutes / 60)

      dispatch('setInGameTime', {
        hours,
        minutes: minutes % 60
      })
    },

    setInGameDay ({ commit, getters }, day) {
      commit('setInGameTime', {
        inGameDay: Math.max(day || 0, 1)
      })
    },

    setInGameTime ({ commit, getters }, { hours, minutes }) {
      commit('setInGameTime', {
        inGameHours: isNumber(hours) ? hours : getters.inGameHours,
        inGameMinutes: isNumber(minutes) ? minutes : getters.inGameMinutes
      })
    }

  }

}
